import { FC } from 'react'
import styled from 'styled-components'
import { useQAAssessmentActionsContext } from 'contexts/QAAssessmentActionsContext'
import { getCssSelectorForLinkId } from 'utils/helpers'
import { useQAAssessmentCommentsContext } from 'contexts/QAAssessmentCommentsContext'
import { getCommentQuestionLinkId } from 'components/QA/Assessments/helpers'
import { useAssessmentContext } from 'contexts/AssessmentContext'
import { generateQAComponentStyles, QAComponentType } from './styles'

interface QuestionContainerProps {
  linkId: string
  children?: React.ReactNode
}

const QuestionContainer: FC<QuestionContainerProps> = ({ linkId, children }) => {
  const {
    assessmentStatusState: { inQA, inQAEdit }
  } = useAssessmentContext()
  const { createCommentClickHandler, disableHover } = useQAAssessmentActionsContext()
  const { sortedComments: comments, focusedCommentId } = useQAAssessmentCommentsContext()
  const focusedComment = comments.find((c) => c.id === focusedCommentId)
  const focusedCommentLinkId = focusedComment ? getCommentQuestionLinkId(focusedComment) : null

  const handleQuestionClick = (): void => {
    // TODO: allow clicking on a question to go to an existing comment
    createCommentClickHandler(linkId)
  }

  return (
    <QuestionContainerDiv
      key={linkId}
      id={getCssSelectorForLinkId(linkId)}
      inQA={inQA}
      inQAEdit={inQAEdit}
      isFocused={linkId === focusedCommentLinkId}
      disableHover={disableHover}
      onClick={handleQuestionClick}
    >
      {children}
    </QuestionContainerDiv>
  )
}

const QuestionContainerDiv = styled.div<QAComponentType>`
  .ant-form-item {
    margin-bottom: 0;
  }

  ${(qaComponentProps) => generateQAComponentStyles(qaComponentProps)}
`

export default QuestionContainer
